import ProjectsGrid from "../components/projects/ProjectsGrid";

function Projects() {
	return (
		<div className="h-full w-full overflow-auto flex flex-col">
			<ProjectsGrid />
		</div>
	);
}

export default Projects;
